.form-subtitle {
  margin-top: calc(var(--spacer) * 4);
  margin-bottom: calc(var(--spacer) * -1);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

.toggle-subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

gz-title + gz-form-field {
  margin-top: calc(var(--spacer) * 3.5);
}

.infoText {
  color: var(--body-text-arrows-400);
}

.field-with-icon-row {
  display: flex;

  div {
    flex: 0 0 300px;
    display: flex;
  }

  gz-icon {
    margin-bottom: 15px;
  }

  gz-icon + gz-icon {
    margin-left: 5px;
    margin-bottom: 18px;
  }
}

#content-control-traffic-exclusions-text {
  margin-bottom: calc(var(--spacer) * -2);
}

#content-control-traffic-scan-ssl-content,
#content-control-traffic-scan-ssl-mitm-enabled-form-field {
  margin-left: 27px;
}

#content-control-traffic-scan-ssl-mitm-processes-form-field {
  margin-left: 54px;
}

#content-control-traffic-scan-mapi-text {
  max-width: 600px;
}

#content-control-traffic-scan-text {
  max-width: 700px;
}
